import { OBJECT } from '@pkg/config/sanity/schemas';
import { blockBaseTextFields } from './inner/BaseText';
import { blockButtonGroupFields } from './inner/ButtonGroup';
import { blockSalesforceFormsFields } from './inner/SalesforceForm';
import { blockCalloutFields } from './inner/Callout';
import { blockFaqBlockFields } from './inner/FAQ';
import { blockFormsFields } from './inner/Forms';
import { blockPeopleListFields } from './inner/PeopleList';
import { blockStatisticsFields } from './inner/Statistics';
import { blockTickerFields } from "./inner/Ticker";
import { blockTitleFields } from './inner/Title';
import { blockCarouselSectionFields } from './outer/CarouselSection';
import { blockSignatureGeneratorFields } from './outer/SignatureGenerator';
import { blockCookieListFields } from './outer/CookieList';
import { blockMainHeroFields } from './outer/MainHero';
import { blockCareersFields } from './outer/Careers';
import { blockSectionFields } from './outer/Section';
import { blockSolutionFinderFields } from './outer/SolutionFinder';
import { blockSupportSectionFields } from './outer/SupportSection';
import { blockStepsSectionFields } from './outer/StepsSection';
import { blockSubHeroFields } from './outer/SubHeroSection';
import { blockSurpriseBagFinder } from './outer/SurpriseBagFinder';
import { blockTickerSectionFields } from './outer/TickerSection';
import { blockVideoFields } from './inner/Video';
import { blockBagSectionFields } from './outer/BagSection';
import { blockProfilePictureFields } from './inner/ProfilePicture';
import { blockPartnerLogoFields } from './inner/PartnerLogo';
import { blockLocationFinderFields } from './outer/LocationFinder';
import { blockCampaignCounterFields } from './inner/CampaignCounter';
import { blockSimpleCounterFields } from './inner/SimpleCounter';
import { blockCTASectionFields } from './outer/CTASection';
import { blockImageVideoFields } from './outer/ImageVideo';
import { blockTilesFields } from './inner/Tiles';
import { blockNudgeFields } from './inner/Nudge';
import { blockSolutionTilesFields } from './inner/SolutionTiles';
import { blockListingFields } from './inner/Listing';
import { blockReferralSectionFields } from './outer/Referral';
import { blockPrivacyControlsSectionFields } from './outer/PrivacyControls';

/**
 * Add all outer blocks to the below object.
 * This is required to generate the correct groq query for modular content outer blocks;
 */
export const outerBlocksFieldsData: Array<{ name: OBJECT, fields: string }> = [
  { name: OBJECT.MODULAR_OUTER_BLOCK_SECTION, fields: blockSectionFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_HERO, fields: blockMainHeroFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_SUB_HERO, fields: blockSubHeroFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_CAROUSEL_SECTION, fields: blockCarouselSectionFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_TICKER_SECTION, fields: blockTickerSectionFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_STEPS_SECTION, fields: blockStepsSectionFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_CTA, fields: blockCTASectionFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_CAREERS, fields: blockCareersFields },
  { name: OBJECT.MODULAR_OUTER_IMAGE_VIDEO, fields: blockImageVideoFields },
  { name: OBJECT.MODULAR_OUTER_SOLUTION_FINDER, fields: blockSolutionFinderFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_BAG, fields: blockBagSectionFields },
  { name: OBJECT.MODULAR_OUTER_SUPPORT_SECTION, fields: blockSupportSectionFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_SIGNATURE_GENERATOR, fields: blockSignatureGeneratorFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_REFERRAL, fields: blockReferralSectionFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_COOKIE_LIST, fields: blockCookieListFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_SURPRISE_BAG_FINDER, fields: blockSurpriseBagFinder },
  { name: OBJECT.MODULAR_OUTER_BLOCK_LOCATION_FINDER, fields: blockLocationFinderFields },
  { name: OBJECT.MODULAR_OUTER_BLOCK_PRIVACY_CONTROLS, fields: blockPrivacyControlsSectionFields },
];

/**
 * Add all inner blocks to the below object.
 * This is required to generate the correct groq query for modular content used inside outer blocks.
 */
export const innerBlocksFieldsData: Array<{ name: OBJECT, fields: string }> = [
  { name: OBJECT.MODULAR_INNER_BLOCK_TITLE, fields: blockTitleFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_BASE_TEXT, fields: blockBaseTextFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_BASE_BUTTON_GROUP, fields: blockButtonGroupFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_SALESFORCE_FORMS, fields: blockSalesforceFormsFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_FAQ, fields: blockFaqBlockFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_STATISTICS, fields: blockStatisticsFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_PEOPLE, fields: blockPeopleListFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_TICKER, fields: blockTickerFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_CALLOUT, fields: blockCalloutFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_FORMS, fields: blockFormsFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_VIDEO, fields: blockVideoFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_PROFILE_PICTURE, fields: blockProfilePictureFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_PARTNER_LOGO, fields: blockPartnerLogoFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_LISTING, fields: blockListingFields},
  { name: OBJECT.MODULAR_INNER_BLOCK_TILES, fields: blockTilesFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_NUDGE, fields: blockNudgeFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_SOLUTION_TILES, fields: blockSolutionTilesFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_COUNTER_HERO, fields: blockCampaignCounterFields },
  { name: OBJECT.MODULAR_INNER_BLOCK_SIMPLE_COUNTER, fields: blockSimpleCounterFields },
];